import React from 'react';
import ReactDOM from 'react-dom';
import { ContactProgressPageProps } from '@/features/contact-progress';
import { CompBlockProps } from '@/features/chat-messages/types/comp-block';
import { PageDialogWrapper } from '../../../base/pageDialogWrapper';
import { AgentProgressPage } from '@/features/agent-progress';

export type InquiryDetailPortalProps = Pick<ContactProgressPageProps, 'inquiryId' | 'sessionId'> &
  Pick<CompBlockProps, 'dialogWrpperRef'> & {
    open: boolean;
    onClose: () => void;
  };

export const InqueryDetailPortal: React.FC<InquiryDetailPortalProps> = props => {
  const { inquiryId, sessionId, onClose, dialogWrpperRef, open } = props;
  return (
    <React.Fragment>
      {/* 建联进度弹窗 */}
      {open && inquiryId && dialogWrpperRef?.current
        ? ReactDOM.createPortal(
            <PageDialogWrapper>
              <AgentProgressPage
                inquiryId={inquiryId}
                sessionId={sessionId}
                onClose={() => {
                  onClose();
                }}
              />
            </PageDialogWrapper>,
            dialogWrpperRef.current
          )
        : null}
    </React.Fragment>
  );
};
